import React, { Component } from 'react';
import ReactGA from 'react-ga';

import firebase from "../firebase/FirebaseProvider";
import { withRouter } from 'react-router';
import './logout.css';

class Logout extends Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout() {
    const self = this;
    ReactGA.event({
      category: 'Login',
      action: 'Logout Button Click'
    });
    firebase.auth().signOut().then(function () {
      // console.log("You are now logged out");
      self.props.history.push("/login");
    }, function (error) {
      const errorMsg = JSON.stringify(error);
      ReactGA.event({
        category: 'Login',
        action: 'Logout Error',
        label: errorMsg
      });
    });
  }

  render() {
    return (
      <button className='logout' onClick={this.handleLogout}>Logout</button>
    );
  }
}

export default withRouter(Logout);